import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { sharedConstants } from 'src/environments/constants';

@Injectable({
  providedIn: 'root',
})
export class MuCryptService<ResponseType> {
  constructor() {
    /** ***/
  }

  /**
   * encrypt with aes
   * @param {ResponseType} value
   * @returns {string} resposne
   */
  encrypt(value: ResponseType, hex?: boolean): string {
    const enc = CryptoJS.AES.encrypt(JSON.stringify(value), sharedConstants.cryptoKey).toString();
    return hex ? this.encryptHex(enc) : enc;
  }

  /**
   * decrypt with aes
   * @param {string} value
   * @returns {ResponseType} response
   */
  decrypt(value: string, hex?: boolean): ResponseType {
    const tmp = hex ? this.decryptHex(value) : value;
    const response = CryptoJS.AES.decrypt(tmp, sharedConstants.cryptoKey).toString(CryptoJS.enc.Utf8);
    return JSON.parse(response);
  }

  /**
   * encrypt with hexadecimal
   * @param {string} value
   * @returns {string} response
   */
  encryptHex(value: string): string {
    let encrypted = '';
    for (const [index] of value.split('').entries()) {
      encrypted += ('000' + value.charCodeAt(index).toString(16)).slice(-4);
    }
    return encrypted;
  }

  /**
   * decrypt hexadecimal
   * @param {string} value
   * @returns {string} response
   */
  decryptHex(value: string): string {
    const matches = value.match(/.{1,4}/g) || [];
    let decrypted = '';
    for (const [index] of matches.entries()) {
      decrypted += String.fromCharCode(parseInt(matches[index], 16));
    }
    return decrypted;
  }
}
